import { EditRiwayatPendidikanPayload } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allRiwayatPendidikanKey } from "../../queries/RiwayatPendidikan/useFetchAllRiwayatPendidikan";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editRiwayatPendidikan(
  data: EditRiwayatPendidikanPayload
) {
  const res = await ApiClient.put(`/EditPendidikan`, data);
  return res.data;
}

export const useEditRiwayatPendidikan = mutationWrapper(editRiwayatPendidikan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allRiwayatPendidikanKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
